import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { recursosCompartido } from 'src/app/recursos/cosumoGeneral.service';
import { recursosBecas } from 'src/app/recursos/interfaz';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-req-especifico-operario',
  templateUrl: './req-especifico-operario.component.html',
  styleUrls: ['./req-especifico-operario.component.css']
})
export class ReqEspecificoOperarioComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public vecRequisito = []; public nombreBeca: string = ""; public vecDataRequisito = []; public vecFuenteRequisito = []; public vecFormato: any;
  public vecAddRequisito = []; public tituloModal: string; private accion: number; private periodoCod = '';
  private tokenDrive: string = ''; fileReq: any;
  public rutaCarga: SafeResourceUrl | undefined; public enlaceCarga: string = '';

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private srvGeneral: recursosCompartido,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService, private recBecas: recursosBecas) { }

  async ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.nombreBeca = localStorage.getItem('modNom');
    this.cargarReqEspecifico(1);
    this.verTodosRequisitos();
    this.tokenDrive = await this.srvGeneral.getTokenLocal();
  }
  //OBTENER TODOS LOS REQUSITOS REGISTRADOS
  async verTodosRequisitos() {
    this.vecDataRequisito = [];
    //OBTENER TODOS LOS REQUISITOS REGISTRADOS EN LA BASE DE DATOS
    const resGen = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(14, 'na', 'na', 'na').subscribe(translated => { resolve(translated) }));
    if (resGen.success)
      this.vecDataRequisito = resGen.especifico;
  }
  //FUNCION QUE CARGA TODOS LOS REQUISITOS ESPECIFICOS DEL TIPO DE BECA SELECCIONADO
  async cargarReqEspecifico(op) {
    this.cargando.abrir();
    this.reiniciarTabla();
    this.vecRequisito = []; this.vecFuenteRequisito = [];
    //OBTENER EL PERIODO VIGENTE A LA FECHA ACTUAL
    const resPer = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(10, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPer.success) {
      this.periodoCod = resPer.carrera[0].strCodigo;
      //OBTENER LAS FUENTES DE LOS REQUISITOS
      const resFuente = await new Promise<any>(resolve =>
        this.srvSelect.gestionRequisitos(15, localStorage.getItem('modBeca'), this.periodoCod, 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resFuente.success)
        this.vecFuenteRequisito = resFuente.especifico;
      //OBTENER LOS REQUISITOS ESPECÍFICOS DADO LA BECA Y PERÍODO
      const resRequisito = await new Promise<any>(resolve =>
        this.srvSelect.gestionRequisitos(1, localStorage.getItem('modBeca'), this.periodoCod, 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resRequisito.success) {
        for (let objEsp of resRequisito.especifico) {
          if (op == 1) {
            if (objEsp.reqEstado == 1)
              this.vecRequisito.push({ especifico: objEsp });
          }
          else
            this.vecRequisito.push({ especifico: objEsp });
        }
      }
      else
        this.obtenerRequisitos();
    }
    else
      this.alerti.warning('A la fecha actual no hay período académico vigente');
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //FUNCION QUE OBTIENE LOS ULTIMOS REQUISITOS SUBIDOS PARA UN TIPO DE BECA
  async obtenerRequisitos() {
    const resReq = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(12, localStorage.getItem('modBeca'), 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resReq.success) {
      this.srvInsert.ingresoGestionRequisitos(resReq.especifico, this.periodoCod, localStorage.getItem('ciUsuario'),
        'na', 'na', 'na', 'na', 1, 2).subscribe(res => {
          if (res.requisito) {
            this.reiniciarTabla();
            this.cargarReqEspecifico(1);
          }
        });
    }
  }
  //FUNCION QUE ABRE EL MODAL PARA AGREGAR UN REQUISITO ESPECIFICO
  modalNuevoRequisito(nameMod) {
    if (localStorage.getItem('insUser') == 'true') {
      this.tituloModal = "Ingresar un requisito especíifico"; this.accion = 1;
      this.instanciaRequisito(0, '', '', 1, this.periodoCod, localStorage.getItem('modBeca'), localStorage.getItem('ciUsuario'), '', 1);
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE ABRE EL MODAL PARA MIGRAR REQUISITOS ESPECIFICOS
  verModMigraRequisito(nameMod) {
    if (localStorage.getItem('insUser') == 'true') {
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR UN REQUISITO
  modalModRequisito(nameMod, objRol) {
    if (localStorage.getItem('modUser') == 'true') {
      if (objRol.codPeriodo == this.periodoCod) {
        this.tituloModal = "Modificar el requisito"; this.accion = 4;
        this.instanciaRequisito(objRol.intIdRequisito, objRol.strNombre, objRol.strDescripcion, objRol.reqEstado, objRol.codPeriodo, objRol.intTipoBeca,
          objRol.regEsp, objRol.formulario, objRol.intIdFuente);
        this.mr = this.modalService.open(nameMod);
      }
      else
        this.alerti.error("No puede editar un requisito de un período anterior");
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE PERMITE AGREGAR O EDITAR UN REQUISITO ESPECIFICO
  agregarRequisito(op) {
    this.srvInsert.ingresoGestionRequisitos(this.vecAddRequisito[0].idReq, this.vecAddRequisito[0].nombre, this.vecAddRequisito[0].detalle,
      this.vecAddRequisito[0].estado, this.vecAddRequisito[0].periodo, this.vecAddRequisito[0].beca, this.vecAddRequisito[0].rol,
      this.vecAddRequisito[0].tipoReq, this.accion).subscribe(res => {
        if (res.requisito) {
          if (this.accion == 1) {
            this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), localStorage.getItem('perfilAudita'), 'ingresoGestionRequisitos()', 'INGRESAR / EDITAR un requisito especifico',
              this.accion, ' Id_Req_Esp - ' + this.vecAddRequisito[0].idReq + '; Nombre_Tipo_Req - ' + this.vecAddRequisito[0].nombre + '; Detalle_Tipo_Req - ' +
              this.vecAddRequisito[0].detalle + '; Estado_Tipo_Req - ' + this.vecAddRequisito[0].estado, 1).subscribe(res => { });
          }
          this.reiniciarTabla();
          this.cargarReqEspecifico(1);

          this.alerti.success('Requisito ingresado correctamente');
        }
        else
          this.alerti.error("No se pudo registrar la información.");
      });
    if (op == 1)
      this.cerrarModal();
  }
  //FUNCION PARA MODIFICAR EL ESTADO DE UN REQUISITO
  async cambiarEstado(beca) {
    if (localStorage.getItem('modUser') == 'true') {
      if (beca.codPeriodo == this.periodoCod) {
        this.accion = 4;
        await this.instanciaRequisito(beca.intIdRequisito, beca.strNombre, beca.strDescripcion, beca.reqEstado == 1 ? 0 : 1, beca.codPeriodo, beca.intTipoBeca,
          beca.regEsp, beca.formulario, beca.intIdFuente);
        this.agregarRequisito(0);
      }
      else
        this.alerti.error("No puede editar un requisito de un período anterior");
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION PARA MIGRAR UN REQUISITO
  async migraRequisito(objRequisito) {
    if (localStorage.getItem('modUser') == 'true') {
      this.srvInsert.ingresoGestionRequisitos(localStorage.getItem('modBeca'), objRequisito.intIdRequisito, this.periodoCod, localStorage.getItem('ciUsuario'),
        'na', 'na', 'na', 2, 2).subscribe(res => {
          if (res.requisito) {
            this.reiniciarTabla();
            this.cargarReqEspecifico(1);
          }
        });
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //INSTANCIAR LAS VARIABLES 
  instanciaRequisito(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9) {
    this.vecAddRequisito = [];
    this.vecAddRequisito.push({
      idReq: dato1, nombre: dato2, detalle: dato3, estado: dato4, periodo: dato5, beca: dato6, rol: dato7, formulario: dato8, tipoReq: dato9
    });
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    var table3 = $('#tblEspecifico').DataTable({ destroy: true });
    table3.destroy();
  }
  //ABRIR EL MODAL QUE PERMITE VER EL FORMULARIO
  async verArchivoFormato(nombModal: any, rutaArchivo: any) {
    this.vecFormato = rutaArchivo;
    this.cargando.abrir();
    if (rutaArchivo.formulario != '' && rutaArchivo.formulario != undefined) {
      this.rutaCarga = ''; this.enlaceCarga = '';
      this.rutaCarga = await this.srvGeneral.obtenerArchivoPDF(this.tokenDrive, rutaArchivo.formulario);
      this.enlaceCarga = await this.srvGeneral.obtenerRutaPDF(this.tokenDrive, rutaArchivo.formulario);
    }
    else
      this.alerti.message('No contiene un formato este requisito');
    this.mr = this.modalService.open(nombModal);
    this.cargando.cerrar();
  }

  //FUNCION QUE OBTIENE EL FILE DEL DOCUMENTO A SUBIR
  async subirFormatoPDF(evento) {
    this.cargando.abrir();
    this.tokenDrive = await this.srvGeneral.getTokenLocal();
    let rutaCarga = '';
    rutaCarga = 'Formato_Requisitos/Periodo_' + this.vecFormato.especifico.codPeriodo + '/BECA_ID_' + this.vecFormato.especifico.intTipoBeca
      + '/ReqEspecificos/Per_' + this.vecFormato.especifico.codPeriodo + '_Beca_ID_' + this.vecFormato.especifico.intTipoBeca + '_NumReq_' +
      this.vecFormato.especifico.intIdRequisito + '.pdf';
    this.fileReq = evento.target.files[0];
    this.rutaCarga = evento.target.files[0];
    if (this.fileReq) {
      let formArchivo = new FormData();
      formArchivo.append('idAplicacion', this.recBecas.idAplicacion);
      formArchivo.append('idCredencial', "1");
      formArchivo.append('activo', "true");
      formArchivo.append('ruta', rutaCarga);
      formArchivo.append('file', this.fileReq);

      await this.srvInsert.subirArchivos(formArchivo, this.tokenDrive).subscribe(data => {
        if (data.success) {
          this.srvInsert.ingresoGestionRequisitos(this.vecFormato.especifico.intTipoBeca, this.vecFormato.especifico.intIdRequisito, this.vecFormato.especifico.codPeriodo,
            rutaCarga, 'na', 'na', 'na', 'na', 10).subscribe(res => {
              if (res.requisito) {
                this.alerti.success('subido el documento');
                this.reiniciarTabla();
                this.cargarReqEspecifico(1);
              }
              else
                this.alerti.error("No se pudo ingresar el documento.");
            });

          this.cargando.cerrar();
        }
      });
    }
  }

  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
